<ion-content class="app-page">
  <div class="auth-screen">
    <section class="hero-copy">
      <p class="eyebrow">PingoraX</p>
      <h1 class="hero-title">Build automation without losing your WhatsApp app workflow.</h1>
      <p class="subtle-copy">
        Connect Meta Cloud API, keep the same number with coexistence, and launch template campaigns
        from a clean SaaS control room.
      </p>

      <div class="hero-badges">
        <ion-chip color="primary">Coexistence-ready</ion-chip>
        <ion-chip color="secondary">Template-first</ion-chip>
        <ion-chip color="tertiary">Capacitor-ready</ion-chip>
      </div>
    </section>

    <section class="glass-panel auth-card">
      <p class="eyebrow">Welcome Back</p>
      <h2 class="section-title">Sign in to your workspace</h2>

      <div [formGroup]="form">
        <ion-list lines="none">
          <ion-item>
            <ion-label position="stacked">Email</ion-label>
            <ion-input type="email" formControlName="email"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Password</ion-label>
            <ion-input type="password" formControlName="password"></ion-input>
          </ion-item>
        </ion-list>

        <ion-text color="danger" *ngIf="errorMessage">{{ errorMessage }}</ion-text>

        <ion-button expand="block" (click)="submit()" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Signing in...' : 'Login' }}
        </ion-button>
      </div>

      <p class="subtle-copy auth-foot">
        New here?
        <a routerLink="/auth/register">Create your account</a>
      </p>
    </section>
  </div>
</ion-content>
